<template>
    <div>
        <day-detail
            :anchor="'#today'"
            :title="'Hoy'"
            :day="today"
        />

        <day-detail
            :anchor="'#tomorrow'"
            :title="'Mañana'"
            :day="tomorrow"
        />

        <day-detail
            :anchor="'#todayplus2'"
            :title="'Hoy +2'"
            :day="twoDays"
        />

        <day-detail
            :anchor="'#todayplus3'"
            :title="'Hoy +3'"
            :day="threeDays"
        />

        <!-- <day-detail
            :anchor="'#today'"
            :title="'prueba 25/11/2020'"
            :day="fakeDay"
        /> -->
    </div>
</template>

<script>
import DayDetail from "./DayDetail";
import DaysMixins from '../../components/Mixins/DaysMixins'

export default {
    components: {
        DayDetail
    },
    mixins: [DaysMixins],
    computed: {
        fakeDay () {
            return this.$moment("2020-11-25")
        }
    }
}
</script>